export default {
	props: {
		numSteps: Number,
		currentStep: Number,
		stepNames: Array,
		noTick: Boolean,
		stepType: String,
	},

	computed: {
		progress () {
			return (this.currentStep / this.numSteps) * 100
		}
	},

	methods: {
		back(step) {
			if(this.stepType == "booking") {
				if (step < this.currentStep) {
					this.$router.push(`/booking/${step}${this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''}`);
				}
			} else {
				this.$router.push("/" + this.stepType + "/" + step)
			}
		}
	},
}


// WEBPACK FOOTER //
// ./src/components/booking/progress-steps/progress-steps.js